/**
 * State Management and Cookie Utilities
 */
export const state = {
  section: null,
  productionList: null,
  mediaContainer: null,
  dashPlayer: null,
  autoplayEnabled: true,
  activeItemIndex: 0,
  lastActiveItemIndex: null,
  productionItems: [],
  preloadImages: [],
  fullResPictures: [],
  loadingSpinner: null,
  toggleButton: null,
  sprites: [],
  onPreloadImage: 0,
  selectTimer: null,
};
/*
export function setCookie(name, value, days = 30) {
  const expires = new Date(Date.now() + days * 864e5).toUTCString();
  document.cookie = `${name}=${encodeURIComponent(
    value,
  )}; expires=${expires}; path=/`;
}

export function getCookie(name) {
  return document.cookie
    .split('; ')
    .find(row => row.startsWith(`${name}=`))
    ?.split('=')[1];
}

export function deleteCookie(name) {
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
}
*/